// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import { errorToast, successToast } from 'utils/toastHandler';
import {
  createCostCode,
  getCostCodes,
  updateCostCode,
  deleteCostCode,
  createNote,
  updateNote,
  deleteNote,
} from '../services/cost_code';
import costCodeActions, { Types } from '../actions/cost_code';

function* createCostCodeRequest(action) {
  try {
    const { payload, data } = action;
    const response = yield call(createCostCode, payload);

    yield put(costCodeActions.createCostCodeSuccess({ data: response.data }));
    if (!data.shouldCreateAnother) {
      yield put(costCodeActions.closeCostCodeDrawer());
    }

    yield put(costCodeActions.resetFormFields());
    successToast('Accounting Code Created Successfully');
  } catch (error) {
    yield put(costCodeActions.createCostCodeFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* getCostCodesRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getCostCodes, params);
    yield put(costCodeActions.getCostCodesSuccess(response.data));
  } catch (error) {
    yield put(costCodeActions.getCostCodesFailure());
  }
}

function* updateCostCodeRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateCostCode, params, payload);
    yield put(costCodeActions.updateCostCodeSuccess({ data: response.data }));
    yield put(costCodeActions.closeCostCodeDrawer());
    yield put(costCodeActions.resetFormFields());
    successToast('Accounting Code Updated Successfully');
  } catch (error) {
    yield put(costCodeActions.updateCostCodeFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteCostCodeRequest(action) {
  try {
    const { params } = action;
    const payload = {
      accounting_code_ids: [params.costCodeId],
      archive: true,
    };
    yield call(deleteCostCode, payload);
    yield put(costCodeActions.deleteCostCodeSuccess(params));
    yield put(costCodeActions.closeConfirmationModal());
    successToast('Accounting Code Archived Successfully');
  } catch (error) {
    yield put(costCodeActions.closeConfirmationModal());
    yield put(costCodeActions.deleteCostCodeFailure());
    error?.response?.data?.message && errorToast(error.response.data.message);
  }
}

function* createNoteRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(createNote, payload);

    yield put(costCodeActions.createNoteSuccess({ data: response.data }));
    yield put(costCodeActions.closeNoteModal());
  } catch (error) {
    yield put(costCodeActions.createNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* updateNoteRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateNote, params, payload);

    yield put(costCodeActions.updateNoteSuccess({ data: response.data }));
    yield put(costCodeActions.closeNoteModal());
  } catch (error) {
    yield put(costCodeActions.updateNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteNoteRequest(action) {
  try {
    const { params } = action;
    yield call(deleteNote, params);
    yield put(costCodeActions.deleteNoteSuccess(params));
  } catch (error) {
    yield put(costCodeActions.deleteNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* costCodeWatcher() {
  yield takeLatest(Types.UPDATE_COST_CODE_REQUEST, updateCostCodeRequest);
  yield takeLatest(Types.GET_COST_CODES_REQUEST, getCostCodesRequest);
  yield takeLatest(Types.CREATE_COST_CODE_REQUEST, createCostCodeRequest);
  yield takeLatest(Types.DELETE_COST_CODE_REQUEST, deleteCostCodeRequest);
  yield takeLatest(Types.CREATE_NOTE_REQUEST, createNoteRequest);
  yield takeLatest(Types.UPDATE_NOTE_REQUEST, updateNoteRequest);
  yield takeLatest(Types.DELETE_NOTE_REQUEST, deleteNoteRequest);
}

export default costCodeWatcher;
